import CfopService from "@/services/CfopService";

export const cfop = {
  namespaced: true,
  state: {
    cfop: {},
  },
  actions: {
    getCfop({ commit }, payload) {
      return CfopService.GetCfop(payload).then(
        (cfop) => {
          return Promise.resolve(cfop);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCfop({ commit }, payload) {
      return CfopService.PostCfop(payload).then(
        (cfop) => {
          return Promise.resolve(cfop);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCfop({ commit }, payload) {
      return CfopService.PutCfop(payload).then(
        (cfop) => {
          return Promise.resolve(cfop);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCfop({ commit }, payload) {
      return CfopService.DeleteCfop(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCfopOData({ commit }, payload) {
      return CfopService.GetCfopOData(payload).then(
        (cfop) => {
          return Promise.resolve(cfop);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default cfop;
